const typeEnum = {
  EQC: "4",
  LV1: "1",
  LV2: "2",
  LV3: "3",
};

export default typeEnum;
